var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeicType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 28.5024H34.2154",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 34.0929H34.2154",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 39.6573H34.2154",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6879 1H10.1438C8.85385 1 7.80701 2.04351 7.80701 3.33159V9.54474M29.6879 1V9.95542C29.6879 11.2435 30.7347 12.287 32.0246 12.287H41M29.6879 1L41 12.287M41 12.287V44.7173C41 46.0054 39.9542 47.0489 38.6632 47.0489H10.1438C8.85385 47.0489 7.80701 46.0054 7.80701 44.7173V25.5082",
    stroke: "#C1C1C1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5447 10.5927H1.85883C0.832238 10.5927 0 11.4231 0 12.4474V22.6216C0 23.6459 0.832238 24.4763 1.85883 24.4763H22.5447C23.5713 24.4763 24.4035 23.6459 24.4035 22.6216V12.4474C24.4035 11.4231 23.5713 10.5927 22.5447 10.5927Z",
    fill: "#FF6A30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2819 20.2434C20.8061 20.6788 20.1977 20.8965 19.4566 20.8965C18.5397 20.8965 17.8188 20.6024 17.294 20.0141C16.7692 19.423 16.5068 18.6128 16.5068 17.5834C16.5068 16.4703 16.8053 15.6125 17.4022 15.0098C17.9212 14.4851 18.5815 14.2227 19.3831 14.2227C20.4558 14.2227 21.2401 14.5744 21.736 15.278C22.01 15.673 22.157 16.0695 22.1772 16.4675H20.845C20.7585 16.1618 20.6475 15.9311 20.512 15.7754C20.2698 15.4986 19.9108 15.3602 19.435 15.3602C18.9506 15.3602 18.5685 15.5563 18.2888 15.9484C18.0091 16.3377 17.8693 16.8899 17.8693 17.605C17.8693 18.3201 18.0163 18.8564 18.3105 19.214C18.6075 19.5686 18.9838 19.746 19.4393 19.746C19.9065 19.746 20.2626 19.5931 20.5077 19.2875C20.6432 19.1231 20.7557 18.8766 20.845 18.5479H22.1642C22.0489 19.2428 21.7548 19.808 21.2819 20.2434Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2145 14.3463H15.538V20.7217H14.2145V14.3463Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8477 17.9363H9.75087V19.5755H13.2803V20.7217H8.44897V14.3463H13.1245V15.4752H9.75087V16.829H12.8477V17.9363Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81053 20.7217V17.8757H3.31919V20.7217H2V14.3463H3.31919V16.7771H5.81053V14.3463H7.13405V20.7217H5.81053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeicType);
export default __webpack_public_path__ + "static/media/heic-type.83418b265ac33382a9d97791577b61b0.svg";
export { ForwardRef as ReactComponent };